import axios from 'axios';
import API_BASE_URL from '../../../config/apiConfig';

// HIPAA 45 CFR 164.312(e)(1): la baseURL viene de REACT_APP_API_BASE_URL
// (HTTPS). No hardcodear IPs ni URLs http:// en el código fuente.
export default axios.create({
    baseURL: API_BASE_URL,
});
